import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PurchaseGoalcard from './index';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY, { locale: 'en' });

const PurchaseGoalcardWrapper = () => (
  <Elements stripe={stripePromise} locale="en">
    <PurchaseGoalcard />
  </Elements>
);

export default PurchaseGoalcardWrapper;
